import moment from "moment";
/**
 * Updates the cart meals by replacing the meal with the current meal
 * if it matches the ProgramMealId and MealDate.
 *
 * @param cartMeals - The current list of meals in the cart.
 * @param currentMeal - The meal to update in the cart.
 * @returns A new array of meals with the updated current meal.
 */
export const updateCartMeals = (cartMeals, currentMeal) => {
    return cartMeals
        .map((meal) => meal.ProgramMealId === currentMeal.ProgramMealId &&
        moment(meal.MealDate).isSame(moment(currentMeal.MealDate), "day")
        ? currentMeal
        : meal)
        .filter((meal) => meal.Quantity > 0);
};
